import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
    Event,
    EventSearchCriteria
} from '../../../../../common/models/event.interface';
import { EventViewModel } from '../../models/event-view.model';
import { EventDetailForm, EventDetailUI, EventState } from '../event.state';

export const selectEventState = createFeatureSelector<EventState>('event');

export const selectEventStateData = createSelector(
    selectEventState,
    state => state.data
);

export const selectEventsEntityState = createSelector(
    selectEventStateData,
    data => data.events
);

export const selectPidsMap = createSelector(
    selectEventStateData,
    data => data.pids
);

export const selectEventsUi = createSelector(
    selectEventState,
    (state: EventState) => state.ui
);

export const selectEventGridUi = createSelector(
    selectEventState,
    (state: EventState) => state.ui.eventGrid
);

export const selectEventCreateUi = createSelector(
    selectEventState,
    (state: EventState) => state.ui.eventCreate
);

export const selectEventCreateForm = createSelector(
    selectEventCreateUi,
    (createUi: EventDetailUI) => (createUi ? createUi.form : null)
);

export const selectEventCreateSerializedForm = createSelector(
    selectEventCreateForm,
    (eventForm: EventDetailForm) =>
        eventForm ? eventForm.serializedForm : null
);

export const selectEventCreateFormState = createSelector(
    selectEventCreateForm,
    (eventForm: EventDetailForm) => (eventForm ? eventForm.formState : null)
);

export const selectEventCreateFormAsyncValidations = createSelector(
    selectEventCreateForm,
    (eventForm: EventDetailForm) =>
        eventForm ? eventForm.asyncValidations : null
);

export const selectEventSearchCriteria = createSelector(
    selectEventState,
    (state: EventState) => state.ui.eventSearchCriteria
);

export const selectEventTypes = createSelector(selectEventStateData, data =>
    data.eventTypes ? data.eventTypes : []
);

export const selectEventSearchGroup = createSelector(
    selectEventSearchCriteria,
    (eventSearchCriteria: EventSearchCriteria) =>
        eventSearchCriteria.basicFilters
);

export const selectEventsVM = createSelector(
    selectEventsEntityState,
    selectPidsMap,
    (data, pids) =>
        data.idSort.map((id: number) => {
            let event: Event = data.idMap[id];
            return event ? new EventViewModel(event, pids) : null;
        })
);
